import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'aws-amplify';
import { AgentWrtNoData } from '../../types';
import { captureError } from '../../utils/capture-error';
import { getErrorMessage } from '../../utils/error-message';

export function WrtNoItemDelete(props: {
  AgtNo: string | undefined;
  number: AgentWrtNoData;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();
  // Mutation - Delete Writing Number for Carrier
  const mutation = useMutation({
    mutationFn: async () => {
      await API.post('ContractingAPI', '/agent/carrier-info/delete', {
        body: { AgtNo: props.AgtNo, AgtCarInfoId: props.number.AgtCarInfoId },
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['/agent/carrier-info', { AgtNo: props.AgtNo }],
      });

      props.onClose();
    },
    onError: (error) => captureError({ data: { error } }),
  });

  const handleSubmit = () => {
    mutation.mutate();
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            flex: 1,
            fontFamily: 'Roboto Mono',
            fontSize: 22,
            textDecoration: 'line-through',
            color: '#9b9b9b',
          }}
        >
          {props.number.WrtCarNo}
        </Box>

        <Box>Delete number?</Box>

        <Box sx={{ px: 1 }}>
          <Tooltip title="Delete writing number" placement="left" arrow>
            <span>
              <IconButton
                disabled={mutation.isLoading}
                size="small"
                onClick={handleSubmit}
              >
                {mutation.isLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  <DeleteIcon color="error" />
                )}
              </IconButton>
            </span>
          </Tooltip>
        </Box>

        <Tooltip title="Cancel" placement="bottom" arrow>
          <span>
            <IconButton
              disabled={mutation.isLoading}
              size="small"
              onClick={props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      {mutation.isError ? (
        <Box sx={{ pt: 1 }}>
          <Alert
            onClose={() => mutation.reset()}
            severity="error"
            sx={{ width: '100%' }}
          >
            <strong style={{ marginRight: 10 }}>An error has occurred!</strong>
            <small>
              {getErrorMessage({
                error: mutation.error,
                fallback: 'Please try again.',
              })}
            </small>
          </Alert>
        </Box>
      ) : null}
    </Box>
  );
}
